import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_WORKSPACE_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/onboarding/dashboard`;
export default{
    async listarQuantidade(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/vagas-processadas/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarTempoInclusao(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/tempo-inclusao/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarTempoAlteracao(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/tempo-alteracao/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarTempoAprovacao(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/tempo-aprovacao/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarTempoPendenteAprovacao(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/tempo-pendente-aprovacao/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarDataAdmissao(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/data-admissao/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarPorEmpresa(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/empresa/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarPorDivisao(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/divisao/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarPorLocalidade(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/localidade/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarPorCargo(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/cargo/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },

    async listarPorCentroCusto(dataCadastroInicial, dataCadastroFinal, idPais){
        let url = `${baseUrl}/centro-custo/${idPais}/${dataCadastroInicial}/${dataCadastroFinal}`; //?idPais=${encodeURI(idPais)}

        // if(documento != null && documento != undefined)
        //     url = `${url}&documento=${encodeURI(documento)}`;

        // if(idJobReq != null && idJobReq != undefined)
        //     url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        // if(primeiroNome != null && primeiroNome != undefined)
        //     url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        // if(ultimoNome != null && ultimoNome != undefined)
        //     url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        // if((status || []).length > 0)
        //     status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    } 
}